module.exports = __webpack_public_path__ + "img/section-logo.69b234cc.png";